import { createAction, props } from '@ngrx/store';
import { TripEditRequest } from '../../../models';

export const updateTripEditContext = createAction(
  '[Trip Edit Context] Update Context',
  props<{ 
    tripId: number;
    numberOfParticipants?: number;
    startDate?: Date;
    endDate?: Date;
    tripData?: TripEditRequest;
  }>()
);

export const clearTripEditContext = createAction(
  '[Trip Edit Context] Clear Context'
);

export const initializeTripEditContext = createAction(
  '[Trip Edit Context] Initialize Context',
  props<{ tripData: TripEditRequest }>()
);